<script setup lang="ts">
import type { Form } from '@/services/form'
import type { AppType, CanvasOptions, RulesSet } from '=/types'

const values = defineModel<Form<CanvasOptions>>('values', { required: true })

defineProps<{ rules?: RulesSet; app: AppType }>()
</script>

<template>
  <p class="config__text">{{ app.lang.sizes.description }}</p>
  <div class="config__form two">
    <p class="title">{{ app.lang.sizes.types.height }}</p>
    <template v-for="(height, index) in rules?.sizes.heights" :key="index">
      <label class="select">
        <input type="radio" name="hoogte" :value="height" v-model="values.form.value.sizes.height" />
        {{ height }}mm
      </label>
    </template>
  </div>
  <div v-if="!values.form.value.bond.fixed_widths" class="config__form three">
    <p class="title">{{ app.lang.sizes.types.width }}</p>
    <template v-for="(width, index) in rules?.sizes.widths" :key="index">
      <label class="select">
        <input
          type="radio"
          name="lengte"
          :value="width"
          v-model="values.form.value.sizes.width"
          :checked="values.form.value.sizes.width === width"
          :disabled="values.form.value.bond.fixed_widths"
        />
        {{ width }}mm
      </label>
    </template>
  </div>
</template>
